import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La Homo sin tenas je homoj, bestoj, plantoj, por pli longe sin reteni sur tiu ĉi Tero.
    </p>
    `
  )
}

const itemName = {
  esp: 'La leĝo de tutmonda altriĝo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;